// @ts-nocheck
export const COMPETENCIES_FIELD = 'competencies'
